/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Button from "@mui/material/Button";
import { useCustomer } from "../../provider/Customer/CustomerProvider";
import ContentBox from "../Box/ContentBox/ContentBox";
import { Box, Link } from "@mui/material";
import IconPhone from "../../assets/icons/contract/toggleable/IconPhone";

export default function CallRecordConsent() {
  const { customer } = useCustomer();

  if (!customer) {
    return null;
  }

  return (
    <ContentBox icon={IconPhone} headline={"Persönliche Zusammenfassung von Beratungsgesprächen"} alignContent={"stretch"}>
      <Box
        sx={{
          textAlign: "center",
          marginBottom: "2rem"
        }}>
        Wir bieten Ihnen den kostenlosen Service, Beratungsgespräche automatisch für Sie zusammenzufassen. Hierzu ist ein Mitschnitt des Gesprächs notwendig.
        Mit einem Klick auf “Zustimmung verwalten” können Sie Ihre Einwilligung zur Aufzeichnung von Beratungsgesprächen jederzeit erteilen oder widerrufen.
      </Box>
      <Button fullWidth variant={"contained"} component={Link} href={"/servicewelt/zustimmung-gespraechsaufzeichnung"}>
        Zustimmung verwalten
      </Button>
    </ContentBox>
  );
}
